/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';

type Props = {
  bold?: boolean,
  textAlign?: 'center' | 'left' | 'right',
  children: React.Node,
  desktopSize?: 'large' | 'medium' | 'small',
  disabled?: boolean,
  flexDirection?: 'column' | 'row',
  justifyContent?: 'flex-start' | 'flex-end' | 'space-around' | 'space-between',
  label?: string,
  mobileSize?: 'large' | 'medium' | 'small',
  showLabel?: boolean
};

const defaultProps = {
  bold: false,
  textAlign: 'right',
  desktopSize: 'small',
  disabled: false,
  flexDirection: 'column',
  justifyContent: 'space-around',
  label: undefined,
  mobileSize: undefined,
  showLabel: false
};

const PlayerDatumWrapper = styled.div(
  ({ desktopSize, mobileSize, theme, flexDirection, justifyContent }) => ({
    display: 'flex',
    flexBasis: {
      small: '3rem',
      medium: '4rem',
      large: '5rem'
    }[mobileSize],
    flexDirection,
    flexGrow: 0,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: justifyContent || 'space-around',
    lineHeight: 1.25,
    padding: '0 0.5em',
    textAlign: 'center',
    [theme.mediaQuery.tabletLandscapeAndUp]: {
      flexBasis: {
        small: '3.5rem',
        medium: '4.5rem',
        large: '5.5rem'
      }[desktopSize]
    }
  })
);

const PlayerDatumLabel = styled.span(({ showLabel, theme, paddingRight }) => ({
  color: theme.color.basis4,
  fontSize: theme.fontSize.xxsmall,
  fontWeight: theme.fontWeight.demiBold,
  textTransform: 'uppercase',
  textAlign: 'right',
  whiteSpace: 'nowrap',
  paddingRight: paddingRight ? theme.spacing.xsmall : 0,
  [theme.mediaQuery.tabletLandscapeAndUp]: showLabel
    ? {}
    : {
        display: 'none'
      }
}));

const PlayerDatumValue = styled.span(
  ({ disabled, textAlign, theme }) => ({
    textAlign: textAlign || 'right',
    fontSize: theme.fontSize.small,
    opacity: disabled ? 0.25 : undefined,
    [theme.mediaQuery.tabletLandscapeAndUp]: {
      textAlign: 'center',
      color: theme.color.basis2
    }
  }),
  ({ bold, theme }) => (bold ? { fontWeight: theme.fontWeight.demiBold } : {})
);

function PlayerDatum({
  bold,
  children,
  desktopSize,
  disabled,
  flexDirection,
  justifyContent,
  label,
  mobileSize,
  showLabel,
  textAlign
}: Props) {
  return (
    <PlayerDatumWrapper
      desktopSize={desktopSize}
      mobileSize={mobileSize}
      flexDirection={flexDirection}
      justifyContent={justifyContent}
    >
      <PlayerDatumLabel showLabel={showLabel} paddingRight={flexDirection === 'row'}>
        {label}
      </PlayerDatumLabel>
      <PlayerDatumValue bold={bold} disabled={disabled} textAlign={textAlign}>
        {children}
      </PlayerDatumValue>
    </PlayerDatumWrapper>
  );
}

PlayerDatum.defaultProps = defaultProps;

export default PlayerDatum;
